class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  static megaMenuLeaveBound = false;

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px)');

    if (this.isMegaMenu) {
      const summary = this.mainDetailsToggle.querySelector('summary');

      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.content.addEventListener('mouseenter', this.onMouseEnter.bind(this));

      if (!HeaderMenu.megaMenuLeaveBound && this.header) {
        HeaderMenu.megaMenuLeaveBound = true;
        this.header.addEventListener('mouseleave', HeaderMenu.onHeaderWrapperMouseLeave);
      }

      summary.addEventListener('click', (event) => {
        if (this.hoverMediaQuery.matches) event.preventDefault();
      });
    }
  }

  static onHeaderWrapperMouseLeave(event) {
    const hoverMediaQuery = window.matchMedia('(min-width: 990px)');
    if (!hoverMediaQuery.matches) return;

    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    if (event.relatedTarget?.closest('.header-wrapper') === headerWrapper) return;

    headerWrapper.querySelectorAll('header-menu .mega-menu[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  onMouseEnter() {
    if (!this.isMegaMenu || !this.hoverMediaQuery.matches) return;

    this.header
      ?.querySelectorAll('header-menu .mega-menu[open]')
      .forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
